import Dispatcher from '../../dispatcher';
import { RecordingActionTypes, MicrophoneState } from  '../../common/enums/recordingEnums';

export function SetRecordingDone() {
  Dispatcher.dispatch({
    type: RecordingActionTypes.SetRecordingDone
  });
}

export function SetMicrophonePermissionRetryDialog(isVisible: boolean) {
  Dispatcher.dispatch({
    type: RecordingActionTypes.SetMicrophonePermissionRetryDialog,
    payload: isVisible
  });
}

export function SetRecorderReadyInStore(isReady: boolean) {
    Dispatcher.dispatch({
      type: RecordingActionTypes.SetRecorderReadyAction,
      payload: isReady
    });
}

export function SetRecorderIsPausedInStore(isPaused: boolean) {
    Dispatcher.dispatch({
      type: RecordingActionTypes.SetRecorderIsPaused,
      payload: isPaused
    });
}

export function SetMicrophoneStateInStore(micState: MicrophoneState) {
  Dispatcher.dispatch({
    type: RecordingActionTypes.SetMicrophoneStateAction,
    payload: micState
  });
}

export function SetWarningDismissedInStore() {
  Dispatcher.dispatch({
    type: RecordingActionTypes.SetWarningDismissedAction,
    payload: true
  });
}

export function SetPrivacyDisclaimerClosedFlag(flag: boolean) {
  Dispatcher.dispatch({
    type: RecordingActionTypes.SetPrivacyDisclaimerClosed,
    payload: flag
  });
}